/**
 * @generated SignedSource<<774818c606d09ce458bd05608d45ea0c>>
 * @relayHash 78f55415c515d13db84f3b4805dc867b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 90fe3b8b0a07a64b2330c7c1baf324ae3a91cfe461f07ee60700471f9fb8cf25

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useUpdateCoverPictureMutationPageCreateMutation$variables = {
  pageId: string;
  propertyKey: string;
  propertyValue: string;
};
export type useUpdateCoverPictureMutationPageCreateMutation$data = {
  readonly confluence: {
    readonly createPageProperty: {
      readonly pageProperty: {
        readonly key: string;
        readonly value: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useUpdateCoverPictureMutationPageCreateMutation = {
  response: useUpdateCoverPictureMutationPageCreateMutation$data;
  variables: useUpdateCoverPictureMutationPageCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyValue"
},
v3 = [
  {
    "concreteType": "ConfluenceMutationApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "propertyKey"
              },
              {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "pageId"
              },
              {
                "kind": "Variable",
                "name": "value",
                "variableName": "propertyValue"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "ConfluenceCreatePagePropertyPayload",
        "kind": "LinkedField",
        "name": "createPageProperty",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "ConfluencePageProperty",
            "kind": "LinkedField",
            "name": "pageProperty",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUpdateCoverPictureMutationPageCreateMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUpdateCoverPictureMutationPageCreateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "78f55415c515d13db84f3b4805dc867b",
    "id": "90fe3b8b0a07a64b2330c7c1baf324ae3a91cfe461f07ee60700471f9fb8cf25",
    "metadata": {},
    "name": "useUpdateCoverPictureMutationPageCreateMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateCoverPictureMutationPageCreateMutation($propertyKey:String!,$pageId:ID!,$propertyValue:String!){confluence{createPageProperty(input:{key:$propertyKey,pageId:$pageId,value:$propertyValue}){success,pageProperty{key,value}}}}"
  }
};
})();

(node as any).hash = "5ae86cfe29b1215ceb6c5fdb02e769cc";

export default node;
